import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getTimeOptions } from '../../util';
import { MeetingForAction } from '../../interface';

@Component({
  selector: 'meeting-scheduler-reschedule-meeting',
  templateUrl: './reschedule-meeting-dialog.component.html',
  styleUrls: ['./reschedule-meeting-dialog.component.scss'],
  standalone: false,
})
export class RescheduleMeetingDialogComponent implements OnInit {
  rescheduleForm: UntypedFormGroup;
  timeOptions$$: BehaviorSubject<Date[]> = new BehaviorSubject<Date[]>([]);
  readonly timeOptions$: Observable<Date[]> = this.timeOptions$$.asObservable();
  today = new Date();

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<RescheduleMeetingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public meeting: MeetingForAction,
  ) {}

  ngOnInit(): void {
    this.timeOptions$$.next(getTimeOptions(this.meeting.date.start));

    this.timeOptions$
      .pipe(
        take(1),
        map((options) => {
          return this.fb.group({
            meetingId: [this.meeting.meetingId],
            date: [this.meeting.date.start, Validators.required],
            timeSlot: [this.getDefaultStartTime(options), Validators.required],
            messageToGuest: [null],
          });
        }),
      )
      .subscribe((form) => (this.rescheduleForm = form));

    this.rescheduleForm.get('date').valueChanges.subscribe((date) => {
      const newDate = new Date(date);
      const options = getTimeOptions(newDate);
      this.timeOptions$$.next(options);
      this.rescheduleForm.patchValue({ timeSlot: this.getDefaultStartTime(options) });
    });
  }

  getDefaultStartTime(timeOptions: Date[]): Date {
    // index the 9 AM value from the options if available
    return timeOptions.find((o) => o.getHours() === 9 && o.getMinutes() === 0) || timeOptions[0];
  }

  rescheduleMeeting(): void {
    const rescheduledDate = this.rescheduleForm.value.timeSlot;
    this.dialogRef.close({ meetingId: this.meeting.meetingId, start: rescheduledDate });
  }

  close(): void {
    this.dialogRef.close();
  }
}
